import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Helmet } from 'react-helmet';
import 'react-table/react-table.css';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import Pagination from '../../../components/common/Pagination';
import InfoBar from '../../../components/common/InfoBar';
import { hashHistory } from 'react-router';
import { requestPatientDeductibleStatuses } from '../../../store/patient-deductible-status/PatientDeductibleStatusActions';
import Moment from '../../../components/utils/Moment';
import { hostTitle } from '../../../config/ui';

class PatientDeductibleStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pageSize: 25, page: 0, pages: -1, search: '', sorted: [], filtered: [], selectedOption: 0 };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ selectedOption: event.target.value }, () => this.table.fireFetchData());
  }

  fetchData = state => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map(item => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const filters = state.filtered
      .map(item => `${item.value} ${item.id}`)
      .join();
    const search = this.state.search;
    return this.props
      .getPatientDeductibleStatuses({
        offset: offset,
        limit: limit,
        order: order,
        search: search,
        filters: filters,
        tenantId: this.props.tenantId,
        showValue: this.state.selectedOption
      })
      .then(response =>
        this.setState({
          pages: response.payload
            ? Math.ceil(response.payload.data.total / this.state.pageSize)
            : 0,
        }),
      );
  };

  handleSearch = search =>
    this.setState({ search, page: 0 }, () => this.table.fireFetchData());

  detailPatientDeductible = id => {
    hashHistory.push(`/patient-deductible-status/detail/${id}`);
  };

  render() {
    const { data } = this.props;
    return (
      <div id="content">
        <Helmet title={`Patient Deductible Status Manager – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Administration', 'Patient Deductible Status Manager']}
              icon="fa fa-fw fa-database"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={data.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>Patient Deductible Status Manager</h2>
                </header>
                <div>
                  <div className="widget-body no-padding">
                    <ReactTable
                      ref={instance => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.isLoading}
                      data={this.props.data ? this.props.data.list : []}
                      onFetchData={this.fetchData}
                      columns={[
                        {
                          Header: 'First Name',
                          id: 'firstName',
                          accessor: 'firstName',
                        },
                        {
                          Header: 'Last Name',
                          id: 'lastName',
                          accessor: 'lastName',
                        },
                        {
                          Header: "DOB",
                          id: "dob",
                          accessor: "dob",
                          Cell: row => (
                            <Moment
                              date={row.original.dob}
                              format="MM/DD/YYYY"
                            />
                          ),
                        },
                        {
                          Header: 'Policy Id',
                          id: 'insPolicyId',
                          accessor: 'insPolicyId',
                        },
                        {
                          Header: 'Is Hdhp Member',
                          id: 'isHdhpMember',
                          accessor: d => d.isHdhpMember ? 'True' : 'False',
                          filterable: false
                        },
                        {
                          Header: 'Met Deductible',
                          id: 'metDeductible',
                          accessor: d => d.metDeductible ? 'True' : 'False',
                          filterable: false
                        },
                        {
                          Header: 'Met Oop Max',
                          id: 'metOopMax',
                          accessor: d => d.metOopMax ? 'True' : 'False',
                          filterable: false
                        },
                        {
                          Header: 'Source',
                          id: 'source',
                          accessor: 'source',
                          filterable: false
                        },
                        {
                          Header: 'Modified Date',
                          id: 'modifiedDate',
                          accessor: 'modifiedDate',
                          Cell: row => (row.original.modifiedDate &&
                            <Moment
                              date={row.original.modifiedDate}
                              format="MM/DD/YYYY"
                            />
                          ),
                          filterable: false
                        },
                        {
                          Header: 'Actions',
                          id: 'actions',
                          sortable: false,
                          filterable: false,
                          Cell: row => (
                            <span>
                              <button
                                className="btn btn-primary btn-xs"
                                onClick={() =>
                                  this.detailPatientDeductible(row.original.id)
                                }
                              >Details
                              </button>
                            </span>
                          ),
                        },
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={pageSize => this.setState({ pageSize })}
                      onPageChange={page => this.setState({ page })}
                      filterable
                      className="-striped -highlight"
                      showPaginationTop={true}
                      PaginationComponent={Pagination}
                      onSearchChange={this.handleSearch}
                    />
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.patientdeductiblemanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  dispatch => ({
    getPatientDeductibleStatuses: params => dispatch(requestPatientDeductibleStatuses(params)),
  }),
)(PatientDeductibleStatus);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/PatientDeductibleStatus.js